<template>
  <div class="sortingcenter">
    <div class="bg-white sortingcenter-data pt16 pb32 mb32 pl32 pr32">
        <div class="sortingcenter-data-title">
            <h4 class="title">
                <div></div>
                数据概览
            </h4>
            <div class="search">
                <div class="time">
                    <span class="mr16">交易时间</span>
                    <a-range-picker v-model="dataForm.dataTime" :default-value="dataForm.dataDefaultTime" />
                </div>
                <div class="ml16">
                    <a-button type="primary" @click="dataSearch">查询 </a-button>
                </div>
            </div>
        </div>
        <div class="sortingcenter-data-content">
            <div class="sortingcenter-data-content-item">
                <div class="item">
                    <div class="name">总计回收重量</div>
                    <div class="data">{{ overviewData.weight }} kg</div>
                </div>
            </div>
            <div class="sortingcenter-data-content-item">
                <div class="item" v-for="(item, index) in overviewData.group" :key="index">
                    <div class="name">{{ item.parent_name }}(kg)</div>
                    <div class="data">{{ item.weight }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-white sortingcenter-list pl32 pr32 pt32 pb32">
        <h4 class="sortingcenter-list-title">
            <div></div>
            有毒有害列表
        </h4>
        
        <a-table
            :columns="columns"
            :dataSource="backEndList"
            :rowKey="(record) => record.id"
            bordered
            class="mt24"
            :pagination="pagination"
            @change="pageChange"
        >
        </a-table>
    </div>
  </div>
</template>
<script>
export default {
    name: "sortingcenter",
    data() {
        return {
            form: {},
            dataForm: {},
            columns: [
                {
                    title: "时间",
                    dataIndex: "time",
                    key: 'time'
                },
                {
                    title: "品类",
                    dataIndex: "cate_name",
                    key: 'cate_name'
                },
                {
                    title: "重量(kg)",
                    dataIndex: "weight",
                    key: 'weight'
                },
                {
                    title: "收集点",
                    dataIndex: "block_name",
                    key: 'block_name'
                },
                {
                    title: "车牌号",
                    dataIndex: "car_num",
                    key: 'car_num'
                },
                {
                    title: "清运人",
                    dataIndex: "sorting_name",
                    key: 'sorting_name'
                }
            ],
            pagination: {
                //默认当前页
                defaultCurrent: 1,
                defaultPageSize: 10,
                showTotal() {
                    return `共 ${this.total} 条数据`;
                },
                showSizeChanger: true,
                total: 0
            },
            page: 1,
            page_num: 10,
            backEndList: [],
            overviewData: {}
        };
    },
    created() {
        let nowTime = new Date().getTime();
        /**
         * 获取当前时间前三个月的时间
         * 另一种写法 this.$moment().subtract(1, 'quarters');
         **/
        this.dataForm.dataDefaultTime = [
            this.$moment(nowTime).subtract(3, "months"),
            this.$moment(nowTime),
        ];
        if (this.$route.query.tonglu) {
            setTimeout(() => {
                if (this.dataForm.dataDefaultTime.length) {
                    this.getOverviewList();
                }
                this.getFrontEndList(); 
            }, 500);
        } else {
            if (this.dataForm.dataDefaultTime.length) {
                this.getOverviewList();
            }
            this.getFrontEndList();
        }
    },
    components: {},
    mounted() {},
    methods: {
        // 头部数据重置
        reset() {
            this.page = 1;
            this.page_num = 10;
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.form = {};
            this.getFrontEndList();
        },
        //查询
        search() {
            this.$set(this.pagination, "current", 1);
            this.$set(this.pagination, "pageSize", 10);
            this.page = 1;
            this.page_num = 10;
            this.getFrontEndList(true);
        },
        // 数据查询
        dataSearch() {
            this.getOverviewList(true);
        },
         // 获取数据概览
         getOverviewList(status = false) {
            let dataJson = {};
            let date = this.dataForm.dataTime;
            if (date && date.length) {
                dataJson.start_time = parseInt(
                    this.$moment(date[0]).hour(0).minute(0).second(0).valueOf() / 1000
                );
                dataJson.end_time = parseInt(
                    this.$moment(date[1]).hour(23).minute(59).second(59).valueOf() / 1000
                );
            } else {
                dataJson.start_time = parseInt(
                    this.$moment(this.dataForm.dataDefaultTime[0])
                        .hour(0)
                        .minute(0)
                        .second(0)
                        .valueOf() / 1000
                );
                dataJson.end_time = parseInt(
                    this.$moment(this.dataForm.dataDefaultTime[1])
                        .hour(23)
                        .minute(59)
                        .second(59)
                        .valueOf() / 1000
                );
            }
            this.$api.account.frontEndtoxicoverview(dataJson).then((res) => {
                this.overviewData = res.data;
                status ? this.$message.success(res.msg) : "";
            });
        },
        //获得获取订单列表
        //page:页 page_num每页条数
        getFrontEndList(status = false) {
            this.form.page = this.page;
            this.form.limit = this.page_num;
            this.$api.account.toxicList(this.form).then((res) => {
                this.pagination.total = res.total * 1;
                res.data.list.forEach((el, index) => {
                    el.id = index;
                });
                this.backEndList = res.data.list;
                status ? this.$message.success("共查询到" + res.total + "条信息") : "";
            });
        },
        // 分页
        pageChange(pagination) {
            this.$set(this.pagination, "current", pagination.current);
            this.$set(this.pagination, "pageSize", pagination.pageSize);
            this.page = pagination.current;
            this.page_num = pagination.pageSize;
            this.getFrontEndList();
        },
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
    .sortingcenter {
        &-data {
            &-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .title {
                    display: flex;
                    align-items: center;
                    color: $title-color-black-85;
                    @include pxAndLh(16);
                    font-weight: bold;
                    margin: 0;
                    & > div {
                        width: 5px;
                        height: 20px;
                        background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                        border-radius: 5px;
                        margin-right: 5px;
                    }
                }
                .search {
                    display: flex;
                    align-items: center;
                }
            }
            &-content {
                &-item {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    font-size: 14px;
                    .item {
                        margin-right: 70px;
                        margin-top: 10px;
                        .name {
                            color: #858a90;
                        }
                        .data {
                            color: #363e51;
                            font-weight: 600;
                        }
                        & > div {
                            text-align: center;
                        }
                    }
                }
            }
        }
        &-list {
            &-title {
            display: flex;
            align-items: center;
            color: $title-color-black-85;
            @include pxAndLh(16);
            font-weight: bold;
            margin: 0;
                & > div {
                    width: 5px;
                    height: 20px;
                    background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
                    border-radius: 5px;
                    margin-right: 5px;
                }
            }
            &-search {
                display: flex;
            }
        }
    }
</style>